/* eslint-disable react/jsx-indent */
import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { stateInitializer } from '../@state_manager/reducer_helpers';
import deletionReducer from '../@state_manager/reducer';

const DeletionContext = React.createContext();

export const DeletionStateProvider = ({ children, value = {} }) => {
  const [state, dispatch] = useReducer(deletionReducer, {}, stateInitializer);

  return (
    <DeletionContext.Provider
      value={{ ...value, deletionState: state, dispatch }}
    >
      {children}
    </DeletionContext.Provider>
  );
};

DeletionStateProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.shape({}),
};

export default DeletionContext;



// WEBPACK FOOTER //
// ./src/MultiDeletionFunctionality/@state/DeletionStateContext.jsx